import './MapWrapper.scss';

interface MapWrapperProps {
  children: React.ReactNode;
}

export const MapWrapper: React.FC<MapWrapperProps> = ({ children }) => {
  return <div className='dmx-mapWrapper'>{children}</div>;
};
